import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Rails owns the navigation contract; the native clients own its material.
// Every available native action has a matching hidden HTML control so a
// selection returns to Turbo instead of duplicating routing in Swift/Kotlin.
export default class extends BridgeComponent {
  static component = "app-chrome"
  static targets = ["action"]
  static values = { configuration: Object }

  connect() {
    super.connect()

    this.send("connect", this.configurationValue, (message) => {
      if (message.data?.visit) {
        window.Turbo.visit(message.data.visit)
        return
      }

      const action = this.actionTargets.find(
        (element) => element.dataset.nativeActionId === message.data?.action
      )

      action?.click()
    })
  }
}
